import React from "react";
import PropTypes from "prop-types";
import {
  Card,
  CardHeader,
  CardBody,
  Form,
  FormGroup,
  FormInput,
  FormTextarea,
  Button,
} from "shards-react";
import ToggleButton from "react-toggle-button";
const NewDraft = ({ title, sub, onChangesetSub }) => (
  <Card small className="h-20">
    {/* Card Header */}
    <CardHeader className="border-bottom">
      <h6 className="m-0">{title}</h6>
    </CardHeader>

    <CardBody className="d-flex flex-column">
      <ToggleButton
        value={sub}
        onToggle={(value) => {
          onChangesetSub(!value);
          // self.setState({
          //   value: !value,
          // })
        }}
      />
    </CardBody>
  </Card>
);

NewDraft.propTypes = {
  /**
   * The component's title.
   */
  title: PropTypes.string,
};

NewDraft.defaultProps = {
  title: "New Draft",
};

export default NewDraft;
